"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var modal_style_1 = require("../modal/modal.style");
var theme_1 = require("../theme");
exports.CSS = {
    menu: 'c-Menu',
    isOpen: 'c-Menu--Open',
    isClosed: 'c-Menu--Close',
    isClosing: 'c-Menu--Closing',
    divider: 'c-Menu__Divider',
    item: {
        container: 'c-Menu__Item',
        isSelected: 'c-Menu__Item--Selected'
    }
};
exports.Style = (_a = {},
    _a[exports.CSS.menu] = {
        position: 'absolute',
        top: theme_1.DefaultTheme.space(1),
        right: theme_1.DefaultTheme.space(1),
        'min-width': '160px',
        padding: "".concat(theme_1.DefaultTheme.space(1), " 0"),
        'z-index': modal_style_1.MODAL_Z_INDEX + 1,
        color: theme_1.DefaultTheme.font.color.supporting,
        'background-color': theme_1.DefaultTheme.background.offWhite,
        display: 'flex',
        'flex-direction': 'column',
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp4,
        opacity: 1,
        transition: 'opacity .15s ease-in-out'
    },
    _a[exports.CSS.divider] = {
        'border-bottom': "1px solid ".concat(theme_1.DefaultTheme.font.color.divider),
        margin: "0 ".concat(theme_1.DefaultTheme.space(1))
    },
    _a[exports.CSS.isClosed] = {
        display: 'none'
    },
    _a[exports.CSS.isClosing] = {
        opacity: '0'
    },
    _a);
//# sourceMappingURL=menu.style.js.map